import React, { useState } from "react";
import axios from "axios";
import { ArrowRight, CheckCircle } from "@phosphor-icons/react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SERVICES = ["Solar Energy", "CCTV / Security", "Electric Mobility", "Power Backup", "Digital / Website", "Other"];

export default function LeadForm({ source = "website", compact = false }) {
  const [data, setData] = useState({ name: "", phone: "", email: "", location: "", service: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const onChange = (k) => (e) => setData({ ...data, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!data.name.trim() || !data.phone.trim()) {
      toast.error("Name and phone are required");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, { ...data, source });
      setDone(true);
      toast.success("Thanks! Our team will contact you within 24 hours.");
      setData({ name: "", phone: "", email: "", location: "", service: "", message: "" });
    } catch (err) {
      toast.error("Could not submit. Please call us instead.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="card-flat p-8 flex flex-col items-start gap-4" data-testid="lead-form-success">
        <CheckCircle size={40} weight="duotone" className="text-emerald-500" />
        <div>
          <h3 className="font-heading text-2xl font-bold text-slate-900">Request received</h3>
          <p className="text-slate-600 mt-1 text-sm">Our team will reach out within 24 hours. For urgent queries call +91 88833 35220.</p>
        </div>
        <button onClick={() => setDone(false)} className="text-sm font-semibold text-slate-900 underline" data-testid="lead-form-reset-btn">
          Submit another →
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className={`card-flat ${compact ? "p-6" : "p-8 lg:p-10"} flex flex-col gap-4`} data-testid="lead-form">
      <div className="flex flex-col gap-1">
        <div className="label-eyebrow">Free Quote</div>
        <h3 className="font-heading text-2xl lg:text-3xl font-bold text-slate-900">Get a free site survey</h3>
        <p className="text-sm text-slate-500">Tell us your need — we'll call you back in 24 hours.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <input data-testid="lead-form-name" required placeholder="Your name *" value={data.name} onChange={onChange("name")} className="border border-slate-300 px-4 py-3 text-sm font-body bg-white" />
        <input data-testid="lead-form-phone" required placeholder="Phone number *" value={data.phone} onChange={onChange("phone")} className="border border-slate-300 px-4 py-3 text-sm font-body bg-white" />
        <input data-testid="lead-form-email" type="email" placeholder="Email (optional)" value={data.email} onChange={onChange("email")} className="border border-slate-300 px-4 py-3 text-sm font-body bg-white" />
        <input data-testid="lead-form-location" placeholder="City / Town" value={data.location} onChange={onChange("location")} className="border border-slate-300 px-4 py-3 text-sm font-body bg-white" />
      </div>

      <select data-testid="lead-form-service" value={data.service} onChange={onChange("service")} className="border border-slate-300 px-4 py-3 text-sm font-body bg-white">
        <option value="">Service required</option>
        {SERVICES.map((s) => <option key={s} value={s}>{s}</option>)}
      </select>

      <textarea data-testid="lead-form-message" rows={3} placeholder="Brief message (optional)" value={data.message} onChange={onChange("message")} className="border border-slate-300 px-4 py-3 text-sm font-body bg-white resize-none" />

      <button type="submit" disabled={loading} data-testid="lead-form-submit-btn" className="group inline-flex items-center justify-center gap-2 bg-slate-900 hover:bg-slate-700 text-white px-6 py-3.5 text-sm font-semibold disabled:opacity-60 transition-colors">
        {loading ? "Submitting..." : "Request Free Survey"}
        <ArrowRight size={16} weight="bold" className="group-hover:translate-x-1 transition-transform" />
      </button>
      <p className="text-[11px] text-slate-400">By submitting you agree to be contacted by TamilBTC Technologies.</p>
    </form>
  );
}
